// 👇️ ts-nocheck ignores all ts errors in the file
// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import { useNotify } from "react-admin";
import * as React from "react";
import { Card, TextField,Button,Switch
} from '@material-ui/core';
import {edit_customer_phoneNumber} from './index'
import { useForm ,Controller} from "react-hook-form";
// utils/validators.js
export const validateIranMobile = (value: string): boolean | string => {
    const regex = /^09\d{9}$/;
    if (value) {
      if (!regex.test(value)) {
        return "شماره موبایل صحیح نمیباشد";
      }
      return true;
    }
  };
export function EditPhoneNumber({ resetKey }) {
    interface IFormInput {
        oldMobile: string;
        newMobile: string;
        forceChange:Boolean;
      }
    const {
        register,
        handleSubmit,
        control,
        formState: { errors, isValid },
      } = useForm<IFormInput>({
        mode: "onChange",
        defaultValues: {
            oldMobile: null,
            newMobile:null,
            forceChange:false
        },
      });
    const notify = useNotify()
      const [errorMessages, setErrorMessages] = React.useState([]);
      const [networkState, setNetworkState] = React.useState<NetworkState>("IDLE");
    
      const onSubmit = async (data: IFormInput) => {
        setErrorMessages([]);
        setNetworkState("PENDING");
        const postData = {
            oldMobile: data.oldMobile,
            newMobile: data.newMobile,
            forceChange: data.forceChange,
        };
    
        edit_customer_phoneNumber(postData).then((res)=>{
          console.log("res edit_customer_phoneNumber",res);
          
            if (res.data && res.data.err) {
                setErrorMessages([res.data.err.details.messages[0]]);
                console.log('errorMessages',errorMessages);  
                setNetworkState("FAILED");
            }
            else{
                if (res.data) {
                    if (res.data.status === "SUCCESS") {
                      notify("     تغییر شماره موبایل انجام شد", { type: 'success' })
                      resetKey(Date.now());
                      setNetworkState("SUCCESS");
                    } } }   
          }).catch((err)=>{ })
        }
    return (
        <Card style={{margin:"1rem",}}>
         <h3 style={{fontFamily: 'IranSans-Medium',color:'rgb(71 68 68 / 87%)',marginRight:'3rem'}}>تغییر شماره موبایل کاربر  </h3>
      <form
        style={{
          display: "flex",
          flexDirection: "column",
          gap: "1rem",
          margin:"3rem",
          direction: "rtl",
        }}
        onSubmit={handleSubmit(onSubmit)}
      >
        <TextField
          {...register("oldMobile", {
            required: "شماره موبایل قدیمی را وارد نمایید",
            validate: {
              IranMobile: validateIranMobile,
            },
          })}
          error={!!errors.mobile}
          helperText={errors.mobile ? errors.mobile.message : null}
          fullWidth
          label="شماره موبایل "
          placeholder="09*********"
          variant="outlined"
        /> 
                <TextField
          {...register("newMobile", {
            required: "شماره موبایل  جدید را وارد نمایید",
            validate: {
              IranMobile: validateIranMobile,
            },
          })}
          error={!!errors.mobile}
          helperText={errors.mobile ? errors.mobile.message : null}
          fullWidth
          label="شماره موبایل "
          placeholder="09*********"
          variant="outlined"
        /> 
               <div style={{ display: 'flex', justifyContent: 'end', width: '100%', alignItems: 'center' }}>
       <Controller
        name="forceChange"
        control={control}
        render={({ field }) =>
        <><Switch
            {...field}
            color="primary"
            name="forceChange"
            inputProps={{ 'aria-label': 'secondary checkbox' }} /><p style={{ fontFamily: 'IranSans-Bold', fontSize: '11px' }}>تغییر  با وجود ثبت شدن شماره ازقبل</p></>
      }
      />
       </div>
        <Button
          disabled={!isValid || networkState === "PENDING"}
          fullWidth
          type="submit"
          color="primary"
          variant="contained"
        >
        ثبت
        </Button>

        {networkState === "SUCCESS" && <p>اطلاعات شما با موفقیت ثبت شد</p>}
        {networkState === "PENDING" && <p>در حال ارسال اطلاعات ...</p>}
        {networkState === "FAILED" &&
          (errorMessages.length > 0 ?   <p style={{color:'red'}}>{errorMessages[0]}</p> : <div>خطایی رخ داده است</div> )}
      </form>
   
        </Card >
    )
}